/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Meta_DescriptionInputs */

const es_gift_meta_description = /** @type {(inputs: Gift_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regala una experiencia en el mar con las tarjetas regalo de Zarpar. Elige importe, sorprende a quien quieras y deja que navegue cuando prefiera.`)
};

const gl_gift_meta_description = /** @type {(inputs: Gift_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agasalla unha experiencia no mar coas tarxetas agasallo de Zarpar. Elixe importe, sorprende a quen queiras e deixa que navegue cando prefira.`)
};

const en_gift_meta_description = /** @type {(inputs: Gift_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give a day on the water with Zarpar gift cards. Pick an amount, surprise someone special, and let them sail when it suits them.`)
};

/**
* | output |
* | --- |
* | "Give a day on the water with Zarpar gift cards. Pick an amount, surprise someone special, and let them sail when it suits them." |
*
* @param {Gift_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_meta_description = /** @type {((inputs?: Gift_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_meta_description(inputs)
	if (locale === "en") return en_gift_meta_description(inputs)
	return es_gift_meta_description(inputs)
});